module.exports = __webpack_public_path__ + "media/images/partner/media/im-7ab41a4b98e936cdfb5fb60c3df48bcd.png";